
<notifier-container></notifier-container>
<router-outlet *ngIf="true"></router-outlet>
